<section [attr.aria-busy]="loading">
  <p *ngIf="loading" class="state-message" role="status">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    Ładowanie postępu kursanta…
  </p>

  <div *ngIf="error" class="state-message" role="alert">
    <p>Nie udało się pobrać postępu wykładów.</p>
    <p-button
      label="Spróbuj ponownie"
      icon="pi pi-refresh"
      (onClick)="load()"
      data-clarity-unmask="true"
    ></p-button>
  </div>

  <ng-container *ngIf="!loading && !error">
    <p class="state-message" *ngIf="!categories.length">
      Brak historii kategorii lub postępu wykładów tego kursanta.
    </p>

    <article
      class="category-card"
      *ngFor="let category of categories"
    >
      <header class="category-header">
        <div>
          <div class="category-title">
            <h3>Kategoria {{ category.examName }}</h3>
            <span *ngIf="category.isCurrentCategory" class="current-category">
              Aktualna
            </span>
          </div>
          <span class="context">
            Rozdziały {{ category.chaptersCompleted }}/{{ category.chaptersInCategory }}
            · Slajdy {{ category.lecturesLearned }}/{{ category.lecturesInCategory }}
          </span>
        </div>
        <strong class="category-percentage">{{ category.progress }}%</strong>
      </header>

      <progress
        class="category-progress"
        [value]="category.progress"
        max="100"
        [attr.aria-label]="'Łączny postęp kategorii ' + category.examName"
      ></progress>

      <p-table
        [value]="category.lectures"
        sortMode="single"
        styleClass="lecture-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="lectureName">
              Dział / rozdział <p-sortIcon field="lectureName"></p-sortIcon>
            </th>
            <th>Slajdy</th>
            <th pSortableColumn="overallPercentageProgress">
              Postęp
              <p-sortIcon field="overallPercentageProgress"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-lecture>
          <tr>
            <td>
              <span class="context">{{ lecture.categoryName }}</span>
              <div>{{ lecture.lectureName }}</div>
            </td>
            <td>
              {{ lecture.lecturesLearned }}/{{ lecture.lecturesInCategory }}
            </td>
            <td>
              <span>{{ lecture.overallPercentageProgress }}%</span>
              <progress
                [value]="lecture.overallPercentageProgress"
                max="100"
                [attr.aria-label]="'Postęp: ' + lecture.lectureName"
              ></progress>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </article>
  </ng-container>
</section>

